/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { BaseApi } from './BaseApi';
import { Observable } from 'rxjs';

export class Mailer  {
  endPoint: string = '/api/admin/documents';

  public prepare(email) {
    // TODO Add e-mails to queue
    console.log('Email not implemented.');
  }

  public send() {
    // TODO Iterate through e-mails and send
  }
}
